import { FC, PropsWithChildren } from 'react';
import star from 'assets/img/overlay-star.png';
import './overlayStar.styl';

export const OverlayStar: FC<PropsWithChildren<{}>> = ({ children }) => {
    return (
        <div className="overlay">
            <img src={star} className="overlay-star" />
            <div className="overlay-content">{children}</div>
        </div>
    );
};
